<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'ModuleEmbedContentSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    pageUrl: ''
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Adres strony do osadzenia]]]')" :invalid-feedback="form.$errors.first('settings.pageUrl')" :state="form.$errors.state('settings.pageUrl')">
        <IdeoFormInput v-model="form.settings.pageUrl" name="pageUrl" type="text" />
    </IdeoFormGroup>
</template>
